import photoOffIcon from "@tabler/icons/outline/photo-off.svg";
import React, { useState } from "react";

import StillImage, { type StillImageProps } from "@/components/still-image";
import { cn } from "@/utils/cn";

import Icon from "../icon/icon";

const AVATAR_SIZE = 42;

interface AvatarProps extends Pick<StillImageProps, "src" | "onError" | "className"> {
  /** Width and height of the avatar in pixels. */
  size?: number;
}

/** Round profile avatar for accounts. */
const Avatar = (props: AvatarProps) => {
  const { src, size = AVATAR_SIZE, className } = props;

  const [isAvatarMissing, setIsAvatarMissing] = useState<boolean>(false);

  const handleLoadFailure = () => setIsAvatarMissing(true);

  const style: React.CSSProperties = React.useMemo(
    () => ({
      width: size,
      height: size,
    }),
    [size],
  );

  if (isAvatarMissing) {
    return (
      <div
        style={{
          width: size,
          height: size,
        }}
        className={cn(
          "flex items-center justify-center rounded-full bg-gray-200 dark:bg-gray-800",
          className,
        )}
      >
        <Icon
          src={photoOffIcon}
          className="size-4 text-gray-500 dark:text-gray-700"
        />
      </div>
    );
  }

  return (
    <StillImage
      className={cn("rounded-full", className)}
      style={style}
      src={src}
      alt="Avatar"
      onError={handleLoadFailure}
    />
  );
};

export { Avatar as default, AVATAR_SIZE };
